import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=3fabb47b&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=3fabb47b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fabb47b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fabb47b')) {
      api.createRecord('3fabb47b', component.options)
    } else {
      api.reload('3fabb47b', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=3fabb47b&scoped=true&", function () {
      api.rerender('3fabb47b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8vh90A35nQn5U/JS/comp/CookieBox.vue"
export default component.exports